import { render } from "./deductions-tab.vue?vue&type=template&id=529851a6"
import script from "./deductions-tab.vue?vue&type=script&lang=js"
export * from "./deductions-tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__